"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StepText = exports.StepButton = exports.Root = exports.NavigationBar = exports.Header = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _models = require("../../models");
const getGridTemplateColumns = (selectedStep)=>{
    if (selectedStep === _models.ShoppingStep.Offers) {
        return 'auto minmax(min-content, auto) auto';
    }
    if (selectedStep === _models.ShoppingStep.Checkout) {
        return 'auto auto minmax(min-content, auto)';
    }
    return 'minmax(min-content, auto) auto auto';
};
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        gridArea: 'navigation',
        padding: theme.spacing(0, 3),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(0, 6)
        }
    };
});
const NavigationBar = exports.NavigationBar = (0, _mui.styled)('div')((param)=>{
    let { ownerState: { selectedStep }, theme } = param;
    return {
        display: 'inline-grid',
        gridTemplateColumns: getGridTemplateColumns(selectedStep),
        gap: theme.spacing(3),
        justifyContent: 'start',
        color: theme.palette.text.primary
    };
});
const StepButton = exports.StepButton = (0, _mui.styled)(_components.Button)((param)=>{
    let { ownerState: { isSelected }, theme } = param;
    return {
        textTransform: 'none',
        textDecoration: 'none',
        minWidth: 32,
        color: theme.palette.text.primary,
        borderBottom: '1px solid transparent',
        borderRadius: 0,
        fontWeight: isSelected ? 'bold' : 'normal',
        ["&.".concat(_components.buttonClasses.focusVisible)]: {
            backgroundColor: 'unset',
            borderRadius: theme.shape.borderRadius
        },
        ["&.".concat(_components.buttonClasses.disabled)]: {
            backgroundColor: 'unset',
            color: theme.palette.text.disabled
        },
        ["&.".concat(_components.buttonClasses.root, ":hover")]: {
            background: 'unset',
            borderColor: theme.palette.text.primary,
            color: theme.palette.text.primary
        },
        ["&.".concat(_components.buttonClasses.root, ":focus")]: {
            background: 'unset',
            color: theme.palette.text.primary
        }
    };
});
const StepText = exports.StepText = (0, _mui.styled)(_mui.Typography)({
    display: 'inline-block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 'inherit',
    color: 'inherit',
    lineHeight: 'inherit',
    fontSize: 'inherit'
});
const Header = exports.Header = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        textAlign: 'start',
        margin: theme.spacing(6, 0),
        [theme.breakpoints.up('md')]: {
            textAlign: 'center',
            margin: theme.spacing(3, 0, 12, 0)
        }
    };
});
